import Vue from 'vue'

export function getGaData(pkg, subTotal) {
  let monthNum
  if (pkg.frequency === 'year') {
    monthNum = pkg.frequency_interval * 12
  } else {
    monthNum = pkg.frequency_interval
  }
  let monthsUnit = monthNum > 1 ? 'Months' : 'Month'
  let monName = monthNum + ' ' + monthsUnit

  let deviceUnit = pkg.device_count > 1 ? 'Devices' : 'Device'
  let deviceName = pkg.device_count + ' ' + deviceUnit

  let pkgName = monName + '/' + deviceName

  return {
    'id': pkg.id,
    'name': pkgName,
    'price': subTotal,
    'list': 'PlexVPN',
    'deviceCount': pkg.device_count,
    'quantity': 1
  }
}

export function addImpression(data) {
  if (!window.ga) {
    return
  }
  Vue.$ga.require('ec')
  window.ga('ec:addImpression', data)
  window.ga('send', 'pageview')
}

export function addProduct(data, currentSymbol) {
  if (!window.ga) {
    return
  }
  Vue.$ga.require('ec')
  if (currentSymbol) {
    window.ga('set', 'currencyCode', currentSymbol)
  }
  window.ga('ec:addProduct', data)
}

export function setAction(actionName, actionData) {
  if (!window.ga) {
    return
  }
  Vue.$ga.require('ec')
  window.ga('ec:setAction', actionName, actionData)
  window.ga('send', 'pageview')
}



// WEBPACK FOOTER //
// ./src/assets/js/ecommerceAnalytics.js